import type { SVGProps } from 'react';

const SvgSelectionItemsAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6.5 2h-3A1.5 1.5 0 0 0 2 3.5v3A1.5 1.5 0 0 0 3.5 8h3A1.5 1.5 0 0 0 8 6.5v-3A1.5 1.5 0 0 0 6.5 2m7 0h-3A1.5 1.5 0 0 0 9 3.5v3A1.5 1.5 0 0 0 10.5 8h3A1.5 1.5 0 0 0 15 6.5v-3A1.5 1.5 0 0 0 13.5 2m7 0h-3A1.5 1.5 0 0 0 16 3.5v3A1.5 1.5 0 0 0 17.5 8h3A1.5 1.5 0 0 0 22 6.5v-3A1.5 1.5 0 0 0 20.5 2m-14 7h-3A1.5 1.5 0 0 0 2 10.5v3A1.5 1.5 0 0 0 3.5 15h3A1.5 1.5 0 0 0 8 13.5v-3A1.5 1.5 0 0 0 6.5 9m0 7h-3A1.5 1.5 0 0 0 2 17.5v3A1.5 1.5 0 0 0 3.5 22h3A1.5 1.5 0 0 0 8 20.5v-3A1.5 1.5 0 0 0 6.5 16m7-7h-3A1.5 1.5 0 0 0 9 10.5v3a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 13.5 9m6.79 4.29L14 19.58l-2.29-2.29a.996.996 0 1 0-1.41 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l7-7a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgSelectionItemsAll;
